import { SaleChangeTypeEnum } from '@src/domains/sale-changes/types/saleChange';
import type { DetailedSaleItem } from '@src/domains/sale-items';

export const extractRescheduleSaleChanges = (saleItem: DetailedSaleItem) =>
  saleItem.saleChanges
    .filter((change) => change.type === SaleChangeTypeEnum.Reschedule)
    .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
